var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { css, styled } from '@creditas-ui/system';
import { getTypography, variant } from '@creditas-ui/utilities';

var base = () => css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n"])));

var fontSizeVariantsStyles = props => variant({
  prop: 'size',
  variants: {
    xs: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n      "])), getTypography('bodyXsRegular')(props)),
    sm: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        ", "\n      "])), getTypography('bodyMdRegular')(props)),
    md: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", "\n      "])), getTypography('bodyXlRegular')(props)),
    lg: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        ", "\n      "])), getTypography('headingSmRegular')(props)),
    xl: css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        ", "\n      "])), getTypography('headingMdRegular')(props))
  }
});

var fontColorVariantsStyles = _ref => {
  var {
    theme: {
      avatar
    }
  } = _ref;
  return variant({
    variants: {
      light: {
        color: avatar('light.letter.color')
      },
      dark: {
        color: avatar('dark.letter.color')
      }
    }
  });
};

export var PlaceholderElement = styled(Box)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), base, getTypography('bodyLgRegular'), fontColorVariantsStyles, fontSizeVariantsStyles);
//# sourceMappingURL=Placeholder.style.js.map